module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http", "navigation",
        function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider, navigation) {
        new Service({

            name: 'idTheft',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/idtheft/v1",
            cache: false,

            getGroups: function(){
                return this.get();
            },
            save: function(payload){
                return this.post(payload);
            }
        });
    }]);
};
